import { ForwardedRef, forwardRef } from 'react';
import { Button, ButtonProps } from '@givebutter/primitives/button';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface FloatingChecklistListItemButtonProps extends Omit<ButtonProps, 'variant'> {
    isComplete: boolean;
}
const FloatingChecklistListItemButton = forwardRef(
    (
        { children, className, isComplete, ...rest }: FloatingChecklistListItemButtonProps,
        forwardedRef: ForwardedRef<HTMLButtonElement>,
    ) => {
        return (
            <li>
                <Button
                    ref={forwardedRef}
                    variant="none"
                    className={twMerge(
                        'flex h-12 w-full select-none items-center gap-4 px-4 py-2 text-start',
                        !isComplete && 'hover:bg-gray-100',
                        className,
                    )}
                    {...rest}
                >
                    <FontAwesomeIcon
                        icon={isComplete ? faCircleCheck : faCircle}
                        className={twMerge(
                            'size-4 text-gray-400',
                            isComplete && 'text-success-500',
                        )}
                    />
                    <p
                        className={twMerge(
                            'w-full text-sm font-medium text-gray-700',
                            isComplete && 'text-gray-500 line-through',
                        )}
                    >
                        {children}
                    </p>
                </Button>
            </li>
        );
    },
);

export { FloatingChecklistListItemButton };
